<template>
  <div :class="classes">
    <editorial v-bind="model" :section-style="areaSectionStyle" :actpageFullUrl="common.actpageFullUrl">

      <slot></slot>
    </editorial>
  </div>
</template>

<script>
import { mgnlComponentMixin } from "@wl-vue-mixins/mixins.js";
import Editorial              from "./Editorial";
import Editorial_immersive from "./EditorialHorizontalImmersive.vue";


export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!

  name: "MgnlEditorial",
  components: {
    Editorial,
    Editorial_immersive
  },
  computed: {
    classes() {
      return this.areaModel ? `cell ${this.areaModel.cell}` : '';
    },
    areaSectionStyle() {
      return this.areaModel ? this.areaModel.sectionStyle : this.model.sectionStyle;
    }
  },
  props: ['areaModel']
};
</script>
